
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.4 5.842a.484.484 0 10.684-.684l-.684.684zM.826 2.9a.484.484 0 00-.684.684L.826 2.9zm-.342-.142a.484.484 0 000 .968v-.968zm9.032.968a.484.484 0 000-.968v.968zM.142 2.9a.484.484 0 00.684.684L.142 2.9zm2.942-1.574A.484.484 0 002.4.642l.684.684zM7.6 5.158a.484.484 0 10-.684.684l.684-.684zM9.174 8.1a.484.484 0 10.684-.684l-.684.684zm.342.142a.484.484 0 000-.968v.968zM.484 7.274a.484.484 0 000 .968v-.968zm9.374.826a.484.484 0 00-.684-.684l.684.684zM6.916 9.674a.484.484 0 10.684.684l-.684-.684zM3.084 5.158L.826 2.9l-.684.684L2.4 5.842l.684-.684zm-2.6-1.432h9.032v-.968H.484v.968zm.342-.142l2.258-2.258L2.4.642.142 2.9l.684.684zm6.09 2.258L9.174 8.1l.684-.684L7.6 5.158l-.684.684zm2.6 1.432H.484v.968h9.032v-.968zm-.342.142L6.916 9.674l.684.684L9.858 8.1l-.684-.684z","fill":"#1C2F45"}})])
          )
        }
      }
    